import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/components/pages/home/Home.vue';
import CategoryInsights from '@/components/pages/category-insights/CategoryInsights.vue';
// import EventsCalendar from "@/components/pages/events-calendar/EventsCalendar.vue";
import SingleChart from "@/components/pages/category-insights/SingleChart.vue";

Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: Home
    // },
    {
        path: '/',
        name: 'vertical-insights',
        component: CategoryInsights,
        meta: {
            visible: true
        },
    },
    // {
    //     path: '/events-calendar',
    //     name: 'events-calendar',
    //     component: EventsCalendar,
    //     meta: {
    //         visible: true
    //     },
    // },
    {
        // catch all 404 - define at the very end
        path: "*",
        redirect: () => {
            window.location.href = 'https://www.outbrain.com/404/'
            return ''
        }
    }
    ];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

export default router;
